import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "various-download",
  "use": "various-download-usage",
  "viewBox": "0 0 14 27",
  "content": "<symbol viewBox=\"0 0 14 27\" xmlns=\"http://www.w3.org/2000/svg\" id=\"various-download\"><path d=\"M6 10.005V0h2v10.005h6l-7 14-7-14h6zM0 25h14v2H0v-2z\" fill=\"#e3000f\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol